import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_CONCILIACIONES_BANCARIAS;

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function get(id) {
  return wsService.make_post_request(section + "/get/" + id, {});
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function params() {
  return wsService.make_get_request(section + "/params");
}

function accountStatus(param = {}) {
  return wsService.make_post_request(section + "/account_status", param);
}

function preview(param = {}) {
  return wsService.make_post_request(section + "/preview", param);
}

function upload(param = {}) {
  return wsService.make_post_request(section + "/upload", param);
}

function match(id, param = {}) {
  return wsService.make_post_request(section + "/match/" + id, param);
}

function unmatch(id, param = {}) {
  return wsService.make_post_request(section + "/unmatch/" + id, param);
}

function acceptSuggestions(id, param = {}) {
  return wsService.make_post_request(section + "/accept_suggestions/" + id, param);
}

function partida(id, param = {}) {
  return wsService.make_post_request(section + "/partida/" + id, param);
}

function unpartida(id, param = {}) {
  return wsService.make_post_request(section + "/unpartida/" + id, param);
}

function createMovement(id, param = {}) {
  return wsService.make_post_request(section + "/create_movement/" + id, param);
}

function saveDraft(id) {
  return wsService.make_post_request(section + "/save_draft/" + id, {});
}

function close(id) {
  return wsService.make_post_request(section + "/close/" + id, {});
}

function reopen(id) {
  return wsService.make_post_request(section + "/reopen/" + id, {});
}

function print(id) {
  return wsService.make_post_request(
    section + "/print/" + id,
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

export const conciliacionBancariaService = {
  section,
  filter,
  get,
  remove,
  params,
  accountStatus,
  preview,
  upload,
  match,
  unmatch,
  acceptSuggestions,
  partida,
  unpartida,
  createMovement,
  saveDraft,
  close,
  reopen,
  print,
};
